import { ceres_api } from "@/axios-config.js"

const ProductApplications = {
    createProductApplication(farm_id, model) {
        let endpoint = "/farms/" + farm_id + "/product_applications"
        return ceres_api.post(endpoint, model)
    },
    getProductApplications(farm_id, filter) {
        let endpoint = "/farms/" + farm_id + "/product_applications"
        if (filter == undefined) {
            return ceres_api.get(endpoint)
        } else {
            return ceres_api.post(endpoint + "/filter", { filter: filter })
        }
    },
    getProductApplication(farm_id, id) {
        let endpoint = "/farms/" + farm_id + "/product_applications/"
        return ceres_api.get(endpoint + id)
    }
}

export default ProductApplications
